import React from 'react'

import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import ModalHeader from './ModalHeader'
import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import Details from './Details'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalsContent = () => {
  return (
    <>
      <ModalHeader />
      <LineSeparator color="light2" weight={4} />
      <Grid justify="space-between" align="flex-start" paddingGutter={0.5}>
        <Col flex={2}>
          <Separator weight={6} />
          <Details />
        </Col>
      </Grid>
    </>
  )
}

export default ModalsContent
